export const JSON_LD_CONTEXT = "https://schema.org";

export const BASE_URL = "https://www.jandipr.com";

export const ORG_LEGAL_NAME = "Jandi PR LLC";
export const ORG_BRAND_NAME = "Jandi";

export const ORG_LOGO_PATH = "/Favicon2-512.png";
export const ORG_LOGO_URL = `${BASE_URL}${ORG_LOGO_PATH}`;

export const SUPPORT_EMAIL = "hola@jandipr.com";
export const CONTACT_PAGE_PATH = "/";

export const ORGANIZATION_DESCRIPTION =
  "Jandi connects clients with local service providers in Puerto Rico. Find, hire, and resolve services simply and safely.";

export const ORG_SAME_AS = [
  "https://www.instagram.com/holasoyjandi",
  "https://www.facebook.com/jandi.pr_",
] as const;

export const ORG_ID = `${BASE_URL}/#organization`;
export const WEBSITE_ID = `${BASE_URL}/#website`;

/** Skip JSON-LD on non-production marketing hosts (e.g. QA). */
export function shouldEmitJsonLd(hostname?: string): boolean {
  const host =
    hostname ||
    (typeof window !== "undefined" ? window.location.hostname : "");
  if (!host) return true;
  return !/codesorbit|localhost|127\.0\.0\.1/i.test(host);
}

export function toAbsoluteUrl(pathOrUrl?: string | null): string | undefined {
  if (!pathOrUrl) return undefined;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${BASE_URL}${path}`;
}
